import React from "react";
import SvgMapper from "./SvgMapper";

const TabNavigation = ({ tabs = [], activeTab, onTabClick }) => {
  return (
    <div className="border-b border-gray-200">
      <nav className="flex space-x-8 px-6">
        {tabs.map((tab, index) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={index}
              className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors flex items-center space-x-2 ${
                isActive
                  ? `border-${tab.activeBorder || "yellow-400"} text-${tab.activeText || "yellow-600"}`
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
              onClick={() => onTabClick(tab.id)}
            >
              {SvgMapper[tab.icon] && SvgMapper[tab.icon]("w-4 h-4")}
              <span>{tab.label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default TabNavigation;
